import { Round } from '@/redux/reducers/gameReducer'
import {
  Section,
  YeekeeResultV2Props,
} from '@/ui-components/components/BetLotto/YeekeeResult/YeekeeResultV2'
import { useTranslation } from 'react-i18next'

const useYeekeeResult = () => {
  const { t } = useTranslation()
  const getYeekeeResultProps = (round: Round) => {
    const resultBonus = round?.yeekee_round_bonus_result
    const yeekeeConfig = round?.yeekee_config
    const yeekeeResultNumber =
      parseInt(resultBonus?.summary_result ?? '0') -
      parseInt(resultBonus?.result_row_16 ?? '0')
    const putNumbers = yeekeeResultNumber
      .toString()
      .split('')
      .map((digit) => digit)
    const sectionResult: Section[] = []
    sectionResult.push({
      title: t('betResult.result_yeekee_number'),
      numbers: resultBonus?.summary_result ?? 0,
    })
    sectionResult.push({
      title: t('betResult.put_number_row_16'),
      numbers: resultBonus?.result_row_16 ?? 0,
    })

    const bonusReward: Section[] = []
    if (resultBonus) {
      if (resultBonus.player_username_bonus_1 && yeekeeConfig?.bonus_row_1) {
        bonusReward.push({
          title:
            t('betResult.member_row_number', {
              row: yeekeeConfig?.bonus_row_1,
            }) ?? '',
          numbers: resultBonus.player_username_bonus_1,
        })
      }
      if (resultBonus.player_username_bonus_2 && yeekeeConfig?.bonus_row_2) {
        bonusReward.push({
          title:
            t('betResult.member_row_number', {
              row: yeekeeConfig?.bonus_row_2,
            }) ?? '',
          numbers: resultBonus.player_username_bonus_2,
        })
      }
      if (resultBonus.player_username_bonus_3 && yeekeeConfig?.bonus_row_3) {
        bonusReward.push({
          title:
            t('betResult.member_row_number', {
              row: yeekeeConfig?.bonus_row_3,
            }) ?? '',
          numbers: resultBonus.player_username_bonus_3,
        })
      }
      if (resultBonus.player_username_bonus_4 && yeekeeConfig?.bonus_row_4) {
        bonusReward.push({
          title:
            t('betResult.member_row_number', {
              row: yeekeeConfig?.bonus_row_4,
            }) ?? '',
          numbers: resultBonus.player_username_bonus_4,
        })
      }
    }

    const props: Omit<YeekeeResultV2Props, 'memberPutNumbers'> = {
      putNumbers: putNumbers,
      roundNumber: round.round_number,
      sectionResult: sectionResult,
      bonusReward: bonusReward,
    }
    return props
  }

  return { getYeekeeResultProps }
}

export default useYeekeeResult
